import React, { useContext } from 'react';
import classes from './About.module.css';
import aboutPic from '../../assets/about__pic.png';
import { ThemeContext } from '../../ThemeProvider';
import Reveal from 'react-awesome-reveal';
import { keyframes } from '@emotion/react';

const customAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const About = () => {
  const { dark } = useContext(ThemeContext);

  return (
    <Reveal keyframes={customAnimation} triggerOnce='true' duration={1000} fraction={0.2}>
      <section className={classes.about} id='about'>
        <div className={classes.about__details}>
          <div className={dark ? `${classes.about__title} ${classes.about__title__dark}` : classes.about__title}>
            <h1>
              <span
                className={
                  dark ? `${classes.about__title__num} ${classes.about__title__num__dark}` : classes.about__title__num
                }
              >
                01.
              </span>{' '}
              About Me{' '}
            </h1>
            <div className={classes.about__line}></div>
          </div>

          <p className={dark && classes.desc__dark}>
            I love building web and mobile apps which makes end user's life easy.
          </p>
          <br />

          <p className={dark && classes.desc__dark}>
            I am privileged to work in different domains and roles at a big multi-domain start-up, a re-commerce
            start-up, a fortune 500 company and few fast growing start-ups.
          </p>
          <br />
          <p className={dark && classes.desc__dark}>
            I have been building web and mobile applications using technologies listed below. Been a individual
            contributor and worked on new UI features, rest APIs, refactored existing code wherever possible, created
            tech debts for future refactors, helped team with code reviews and all possible stuffs to deliver a great
            user experience.
          </p>
          <br />
          <p className={dark && classes.desc__dark}>Looking for my next project to help create amazing apps.</p>
          <br />
          <p className={dark && classes.desc__dark}>
            Here are few technologies I've been working with(not limited to):
          </p>
          <div
            className={
              dark ? `${classes.about__techStack} ${classes.about__techStack__dark}` : classes.about__techStack
            }
          >
            <ul>
              <li>HTML5</li>
              <li>CSS3</li>
              <li>Javascript</li>
              <li>Typescript</li>
              <li>React JS</li>
            </ul>
            <ul>
              <li>Redux</li>
              <li>React Native</li>
              <li>Material UI</li>
              <li>Tailwind CSS</li>
              <li>Next JS</li>
            </ul>
            <ul>
              <li>Firebase</li>
              <li>Jest</li>
              <li>MongoDB</li>
              <li>Node JS</li>
              <li>Express JS</li>
            </ul>
          </div>
        </div>
        <div className={classes.about__image__container}>
          <img
            src={aboutPic}
            alt='about__pic'
            className={dark ? `${classes.image} ${classes.image__dark}` : classes.image}
          />
          <div
            className={
              dark ? `${classes.image__background} ${classes.image__background__dark}` : classes.image__background
            }
          ></div>
        </div>
      </section>
    </Reveal>
  );
};

export default About;
